define('vspot-angular/services/wepay-service',[], function () {
    'use strict';

    return ['resources.WePay', function (WePay) {

        return {
            save: function(data) {
                return WePay.save(data);
            },

            get: function (activityId) {
                return WePay.get({ selected_activity: activityId });
            },

            query: function(data) {
                return WePay.query(data);
            },

            /*
             *  Create an account for a particular activity. Failure occurs if trying
             *  to register for an activity that has already been registered.
             *
             *  @param activityId: The id of the activity to operate on.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean }
             */
            accountRegister: function (activityId,wampum_canadian) {
                var url = '/api/wepay/account_register?selected_activity=' + activityId;

                if (wampum_canadian) {
                    url += '&user_country=CA';
                }

                window.location = url;
            },

            /*
             *  Get the account balance for a given activity.
             *
             *  @param activityId: The id of the activity to operate on.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean }
             */
            accountBalance: function (activityId) {
                return WePay.accountBalance({ selected_activity: activityId });
            },

            /*
             *  Update list of available contribution amounts
             *
             *  @param activityId: The id of the activity to operate on.
             *  @param amounts: An array of the form [ { title: 'string', amount: xx.xx } ... ]
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean }
             */
            updateAmounts: function (activityId, amounts) {
                return WePay.updateAmounts({ selected_activity: activityId, amounts: amounts });
            },

            /*
             *  Get the total sales/contributiosn for an activity. Login credentials are
             *  for the volunteer
             *
             *  @param activityId: The id of the activity to operate on.
             *  @param accessKey: The user's access key to authenticate with.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean }
             */
            totalGrossSalesVolunteer: function (activityId, accessKey) {
                return WePay.totalGrossSalesVolunteer({
                    activity_id:    activityId,
                    accesskey:      accessKey
                });
            },

            /*
             *  Get the total sales/contributiosn for an activity. Login credentials are
             *  for the organizer. I.e. logged in on the session.
             *
             *  @param activityId: The id of the activity to operate on.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean }
             */
            totalGrossSalesOrganizer: function (activityId) {
                return WePay.totalGrossSalesOrganizer({
                    selected_activity: activityId
                });
            },

            /*
             * Checkout from the contributions process where the credit card was collectd by embedded checkout and
             * tokenized
             */
            volunteerEmbeddedCheckout: function (activityId, accessKey, amount, credit_card_id,checkout_data) {
                return WePay.volunteerEmbeddedCheckout({
                    activity_id:    activityId,
                    accesskey:      accessKey,
                    amount:         amount,
                    credit_card_id: credit_card_id,
                    checkout:       checkout_data
                });
            }
        };

    }];
});

